export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/right-types', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/right-type', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/right-type/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/right-type/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/right-type/' + data.id, { params: data.filters || {} })
  }
})
